import { render, staticRenderFns } from "./BundleExamConfigurationEditor.vue?vue&type=template&id=ff081548&scoped=true"
import script from "./BundleExamConfigurationEditor.vue?vue&type=script&lang=js"
export * from "./BundleExamConfigurationEditor.vue?vue&type=script&lang=js"
import style0 from "./BundleExamConfigurationEditor.vue?vue&type=style&index=0&id=ff081548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff081548",
  null
  
)

export default component.exports